<template>
  <div class="filter-inner">
    <jw-dropdown :popup-visible="typePopupVisible" popup-container=".leads-content-height" @select="handleTypeDropwn" class="operation-log-select-type">
      <jw-button @click="typePopupVisible = !typePopupVisible" :class="['padding-right-8', 'button-bg-bd', 'type-btn', isActive ? 'type-active' : '']">
        <jw-space>
          <jw-tooltip :content="handleMap[handleType]">
            <!-- <span> -->
            <qfei-icon-business-opportunity-outlined v-if="handleType === 'source'" />
            <qfei-icon-app-one-outlined v-if="handleType === 'type'" />
            <qfei-icon-field-outlined v-if="handleType === 'fields'" />
            <!-- </span> -->
          </jw-tooltip>

          <template v-if="handleType === 'source' || 'type'">
            <template v-if="data.selectType?.length">
              <span :title="showTypeName">{{ showTypeName?.length > 4 ? showTypeName?.substring(0, 4) + '...' : showTypeName }}</span>
              <template v-if="showTips.length > 0">
                <jw-tooltip>
                  <span>+{{ showTips.length }}</span>
                  <template #content>
                    <div v-for="(item, index) in showTips" :key="index">{{ handleTypeList.find((hItem) => hItem.value === item)?.label }}</div>
                  </template>
                </jw-tooltip>
              </template>
              <span @click.stop="clearSearch"><icon-close /></span>
            </template>
          </template>

          <template v-if="handleType === 'fields'">
            <template v-if="data.selectFields?.length">
              <span :title="showFieldsName">{{ showFieldsName?.substring(0, 4) }}</span>
              <template v-if="showTips.length > 0">
                <jw-tooltip>
                  <span>+{{ showTips.length }}</span>
                  <template #content>
                    <div class="tool-tips-wrap">
                      <div class="tool-tips-box" v-for="(item, index) in showTips" :key="index">{{ handleTypeList.find((hItem) => hItem.fieldKey === item)?.fieldName?.length > 10 ? handleTypeList.find((hItem) => hItem.fieldKey === item)?.fieldName.substring(0, 10) + '...' : handleTypeList.find((hItem) => hItem.fieldKey === item)?.fieldName }}</div>
                    </div>
                  </template>
                </jw-tooltip>
              </template>
              <span @click.stop="clearSearch"><icon-close /></span>
            </template>
          </template>
        </jw-space>
      </jw-button>
      <template #content>
        <div class="filter-type-wrap">
          <div class="checkbox-wrap">
            <!-- 操作来源 || 类型 -->
            <template v-if="['source', 'type'].includes(handleType)">
              <div class="type-scroll">
                <jw-checkbox-group v-model="data.selectType" direction="vertical" class="filter-type-group">
                  <jw-checkbox v-for="(item, index) in handleTypeList" :key="index" :value="item.value" :title="item.label">{{ item.label?.length > 6 ? item.label.substring(0, 6) + '...' : item.label }}</jw-checkbox>
                </jw-checkbox-group>
              </div>
            </template>
            <template v-else>
              <!-- 操作字段 -->
              <template v-if="handleTypeList.length">
                <div class="fields-wrap">
                  <jw-input-search size="small" v-model="data.searchFields" :style="{ width: '100%', margin: '4px 4px 4px 4px' }" :placeholder="$t('输入字段名称')" allow-clear />
                  <div class="checkbox-scroll">
                    <jw-checkbox-group v-model="data.selectFields" direction="vertical" class="filter-type-group">
                      <jw-checkbox class="filter-type-checkbox" v-for="(item, index) in data.searchFields ? handleTypeList.filter((hItem) => hItem.fieldName.includes(data.searchFields)) : handleTypeList" :key="index" :value="item.fieldKey" :title="item.fieldName">
                        {{ item.fieldName?.length > 6 ? item.fieldName?.substring(0, 6) + '...' : item.fieldName }}
                      </jw-checkbox>
                    </jw-checkbox-group>
                  </div>
                </div>
              </template>
              <template v-else>
                <jw-empty />
              </template>
            </template>
          </div>
        </div>
      </template>
    </jw-dropdown>

    <teleport to=".drawer-min-width" v-if="typePopupVisible">
      <div class="search-mask" @click="typeCancel"></div>
    </teleport>
  </div>
</template>

<script setup>
import { reactive, ref, computed } from 'vue';
const emits = defineEmits(['cb']);

const props = defineProps({
  handleTypeList: {
    type: Array,
    default: () => []
  },
  handleType: {
    type: String
  }
});

console.log('获取所有字段3', props.handleTypeList);

const data = reactive({
  searchFields: '',
  selectType: [], // 选中的类型
  selectFields: [], // 选中的字段
  prevSelectType: [], // 保存上一次的选中类型
  prevSelectFields: [] // 保存上一次的选中字段
});
const typePopupVisible = ref(false);

const handleMap = {
  type: '操作类型',
  source: '操作来源',
  fields: '操作字段'
};

const isActive = computed(() => {
  if (['source', 'type'].includes(props.handleType)) {
    return data.selectType?.length > 0;
  }
  if (props.handleType === 'fields') {
    return data.selectFields?.length > 0;
  }
  return false;
});

const showTips = computed(() => {
  return ['source', 'type'].includes(props.handleType) ? data.selectType.slice(1) : data.selectFields.slice(1);
});
const showTypeName = computed(() => {
  return props.handleTypeList.find((hItem) => hItem.value === data.selectType[0])?.label;
});

const showFieldsName = computed(() => {
  return props.handleTypeList.find((hItem) => hItem.fieldKey === data.selectFields[0])?.fieldName;
});

// 操作类型遮罩层取消
const typeCancel = () => {
  typePopupVisible.value = false;

  // 判断值是否发生变化
  const currentData = ['source', 'type'].includes(props.handleType) ? data.selectType : data.selectFields;
  const prevData = ['source', 'type'].includes(props.handleType) ? data.prevSelectType : data.prevSelectFields;

  // 比较两个数组是否包含相同的元素（不考虑顺序）
  const areArraysEqual = (arr1, arr2) => {
    if (!arr1 || !arr2) return arr1 === arr2;
    if (arr1.length !== arr2.length) return false;
    return arr1.every((item) => arr2.includes(item)) && arr2.every((item) => arr1.includes(item));
  };

  // 只有当值发生变化时才触发事件
  if (!areArraysEqual(currentData, prevData)) {
    emits('cb', {
      type: props.handleType,
      data: currentData
    });

    // 更新上一次的值
    if (['source', 'type'].includes(props.handleType)) {
      data.prevSelectType = [...data.selectType];
    } else {
      data.prevSelectFields = [...data.selectFields];
    }
  }
};

// 删除
const clearSearch = () => {
  data.selectType = [];
  data.selectFields = [];
  // 清空时一定触发事件
  emits('cb', {
    type: props.handleType,
    data: ['source', 'type'].includes(props.handleType) ? data.selectType : data.selectFields
  });
  // 更新上一次的值
  data.prevSelectType = [];
  data.prevSelectFields = [];
};

// 处理下拉选择
</script>
<style scoped lang="less">
@import './index.less';
</style>
